import { render, staticRenderFns } from "./TokevaInstructionViewer.vue?vue&type=template&id=2be86cd4&scoped=true"
import script from "./TokevaInstructionViewer.vue?vue&type=script&lang=js"
export * from "./TokevaInstructionViewer.vue?vue&type=script&lang=js"
import style0 from "./TokevaInstructionViewer.vue?vue&type=style&index=0&id=2be86cd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be86cd4",
  null
  
)

export default component.exports